import { Card, Col, Row } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";
import { USER_TYPE } from "../../Enums/User.enum.mjs";
import { getDashboard } from "./service";

export default function UsersDashboard() {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [infosDash, setInfosDash] = useState([
    {
      title: t("USERS_2"),
      title_color: theme.titles,
      count: 0,
      count_color: "black",
      description: t("USERS_5"),
      description_color: "black",
      to: "",
    },
    {
      title: t("USERS_3"),
      title_color: theme.titles,
      count: 0,
      count_color: "black",
      description: t("USERS_6"),
      description_color: "black",
      to: "/users/agents",
    },
    {
      title: t("USERS_4"),
      title_color: "white",
      count: 0,
      count_color: "white",
      description: t("USERS_7"),
      description_color: "white",
      color: theme.background_color_base,
      to: "/users/admins",
    },
  ]);

  const findInfoDash = useCallback(async () => {
    const result = await getDashboard();
    setInfosDash([
      {
        title: t("USERS_2"),
        title_color: theme.titles,
        count: result.find((x) => x._id === USER_TYPE.FARMER)
          ? result.find((x) => x._id === USER_TYPE.FARMER).count
          : 0,
        count_color: "black",
        description: t("USERS_5"),
        description_color: "black",
        to: "",
      },
      {
        title: t("USERS_3"),
        title_color: theme.titles,
        count: result.find((x) => x._id === USER_TYPE.AGENT)
          ? result.find((x) => x._id === USER_TYPE.AGENT).count
          : 0,
        count_color: "black",
        description: t("USERS_6"),
        description_color: "black",
        to: "/users/agents",
      },
      {
        title: t("USERS_4"),
        title_color: "white",
        count: result.find((x) => x._id === USER_TYPE.ADMIN)
          ? result.find((x) => x._id === USER_TYPE.ADMIN).count
          : 0,
        count_color: "white",
        description: t("USERS_7"),
        description_color: "white",
        color: theme.background_color_base,
        to: "/users/admins",
      },
    ]);
  }, [t, theme]);

  useEffect(() => {
    findInfoDash();
  }, [findInfoDash]);

  const nextPage = (to) => {
    navigate(to);
  };

  return (
    <Row style={{ marginTop: "10px" }} gutter={[16, 16]} justify="start">
      {infosDash.map((a, index) => {
        return (
          <Col key={index}>
            <Card
              onClick={() => nextPage(a.to)}
              style={{
                cursor: a.to !== "" ? "pointer" : "default",
                width: "319px",
                height: "158px",
                display: "flex",
                backgroundImage: a.color,
              }}
            >
              <div className="card-content">
                <h1 style={{ color: a.title_color }}>{a.title}</h1>
                <h1 style={{ fontSize: "3rem", color: a.count_color }}>
                  {a.count}
                </h1>
                <div
                  className="centered-content"
                  style={{ color: a.description_color }}
                >
                  {a.description}
                </div>
              </div>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}
